/**
 * Shows the sticky buy bar once the real .buy-buttons-block has scrolled out of
 * view, and hides it again once it's back on screen. The bar's own button doesn't
 * add to cart itself - it scrolls back up to and focuses the real buy button, so
 * variant selection / cart AJAX / sold-out states stay handled by the one real form.
 */
class ProductStickyBar extends HTMLElement {
  connectedCallback() {
    this.target = document.querySelector('.buy-buttons-block');
    if (!this.target) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );
    this.observer.observe(this.target);

    const cta = this.querySelector('[data-sticky-cta]');
    cta?.addEventListener('click', () => {
      this.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.target.querySelector('button, [type="submit"]')?.focus();
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('product-sticky-bar')) {
  customElements.define('product-sticky-bar', ProductStickyBar);
}
